import { useQuery, useQueryClient } from "@tanstack/react-query";
import { antecipationService } from "../services/antecipacao-service";
import { AntecipationQueryParams } from "../types";

export const antecipationKeys = {
  all: ["antecipation"] as const,
  lists: () => [...antecipationKeys.all, "list"] as const,
  list: (params: AntecipationQueryParams) =>
    [...antecipationKeys.lists(), params] as const,
};

export function useAntecipationData(
  params: AntecipationQueryParams,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: antecipationKeys.list(params),
    queryFn: async () => {
      const response = await antecipationService.getAntecipationData(params);
      return response.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}

export function useInvalidateAntecipation() {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({
      queryKey: antecipationKeys.all,
    });
  };
}
